import React, { Dispatch, SetStateAction } from "react";
import { Button, Modal, Image } from "react-bootstrap";
import { SettingsMessages, SettingsWarningMessages } from "src/common";
import lockImg from "src/assets/images/account-lock.svg";

type AllProps = {
  func: Function;
  modal_show: boolean;
  setModalShow: Dispatch<SetStateAction<boolean>>;
};

/* Description: confirmation Modal Component for the disconnect, lock and delete device actions. 
Made into a separate component as they all have a similar modal structure - with the lock image and
longer descriptions - hence did not use the MessageHandler component for this. */
function DeviceConfirmationComponent(props: AllProps) {
  const { func, modal_show, setModalShow } = props;
  return (
    <Modal show={modal_show} onHide={() => setModalShow(false)} centered aria-label={SettingsWarningMessages.disconnect_device.title}>
      <Modal.Header>
        <Modal.Title>{SettingsWarningMessages.disconnect_device.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Image alt="Lock Image" className="mb-4 lock-image" src={lockImg} />
        <p><b>{SettingsMessages.confirm_disconnect}</b></p>
        <p className="mb-4">{SettingsWarningMessages.disconnect_device.info}</p>
        <Button className="me-2" onClick={() => { setModalShow(false); func(); }}>Disconnect</Button>
        <Button onClick={() => setModalShow(false)} variant="no-outline-primary">Cancel</Button>
      </Modal.Body>
    </Modal>
  );
}

export default React.memo(DeviceConfirmationComponent);
